import { useMemo } from 'react';

/**
 * Rename keys to have `data-` prefix.
 */
function useDataAttributesProp(dataAttributes) {
    const htmlDataAttributes = useMemo(() => {
        if (!dataAttributes)
            return {};
        return Object.keys(dataAttributes).reduce((acc, key) => {
            acc[`data-${key}`] = dataAttributes[key];
            return acc;
        }, {});
    }, [dataAttributes]);
    return htmlDataAttributes;
}

export { useDataAttributesProp as default };
